import { z } from 'zod';

export const CompanyThirdPartyIds = z.object({
  fnmaServicerId: z.string().optional(),
  fhlmServicerId: z.string().optional(),
  fhaLenderId: z.string().optional(),
  gnmaServicerId: z.string().optional(),
  vaServicerId: z.string().optional(),
  experianId: z.string().optional(),
  transunionId: z.string().optional(),
  equifaxId: z.string().optional(),
  innovisId: z.string().optional(),
  microBiltId: z.string().optional(),
  metro2IdentificationNumber: z.string().optional(),
  leretaCustomerNumber: z.string().optional(),
  corelogicCustomerNumber: z.string().optional(),
});
export type CompanyThirdPartyIds = z.infer<typeof CompanyThirdPartyIds>;
